"use client";

import { twMerge } from "tailwind-merge";

import styles from "./dashboard.module.scss";

export const ClientMyLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={twMerge("relative bg-zinc-100", styles.dashboard)}>
      {children}
    </div>
  );
};
